import React from 'react';
import PropTypes from 'prop-types';

import { StyledTourCardContainer } from './StyledComponents';

const propTypes = {
    hasBigBottomBorder: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'md']),
    isSelected: PropTypes.bool, // adds shadow
    children: PropTypes.node.isRequired,
};

const defaultProps = {
    hasBigBottomBorder: false,
    size: 'sm',
    isSelected: false,
};

const TourCardContainer = ({
    hasBigBottomBorder,
    size,
    isSelected,
    children,
}) => (
    <StyledTourCardContainer
        size={size}
        hasBigBottomBorder={hasBigBottomBorder}
        isSelected={isSelected}
    >
        {children}
    </StyledTourCardContainer>
);

TourCardContainer.propTypes = propTypes;
TourCardContainer.defaultProps = defaultProps;

export default TourCardContainer;
